module.exports = __webpack_public_path__ + "static/media/ic_esign_done_finity.a4bf3e91.svg";